//let baseUrl = 'http://localhost/ppdb-yii/api/web/index.php/';
let baseUrl = 'https://rest.ppdb.arrisalah.sch.id/';
//let baseUrl = 'https://dev.rest.ppdb.arrisalah.sch.id/';

let config = {
  ar : {
    name    : 'Ar-Risalah',
    apps    : 'admin', 
    url     :  baseUrl,   
    rest    :  baseUrl + 'v01/',
    file    :  baseUrl + 'v01/site/', 
    console : true,    
    title   : 'AR-RISALAH',
    prefix  : 'ar',
    color   : 'green darken-4',
    //color   : 'blue-grey',
  },  
} 
export default config['ar'];

